import PropTypes from 'prop-types'
import React from 'react'

import { DownloadIcon } from '@/components/icons'

/**
 * The dashboards' Export: the RO Intake list on one dealer's, the dealer workload table on
 * the all-dealers one. The same button on both, so the two headers match (2026-10-12).
 */
const ExportButton = ({ disabled, exporting, label, onClick }) => (
  <button
    aria-label={label}
    className="flex h-[38px] items-center gap-2 rounded border-[1.5px] border-blue-800 bg-white px-4 text-xs font-bold uppercase tracking-widest text-blue-800 transition-colors hover:bg-blue-50 disabled:cursor-not-allowed disabled:opacity-50"
    disabled={disabled || exporting}
    onClick={onClick}
    type="button"
  >
    <DownloadIcon className="h-4 stroke-blue-800" />
    {exporting ? 'Exporting…' : 'Export'}
  </button>
)

ExportButton.propTypes = {
  disabled: PropTypes.bool,
  exporting: PropTypes.bool,
  // What the export holds, for screen readers: "Export RO Intake".
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

ExportButton.defaultProps = { disabled: false, exporting: false }

export default ExportButton
